import React, { useState, useEffect } from "react";
import { api_interceptor } from "../State/Interceptor/interceptor";
import { ServerURL, getData } from "../store/FetchNodeServices";
import { DisplayDataComponent } from "../Components/DisplayData/DisplayDataComponent";
import { useNavigate } from "react-router-dom";
import "./Form.css";

export default function DisplayForm(props) {
  const navigate = useNavigate();

  const [data, setdata] = useState([]);
  const [value, setValue] = useState("");
  const [source, setSource] = useState("");
  const [loading, setloading] = useState(false);

  const [selectedSourceData, setselectedSourceData] = useState([]);

  const [availableZones, setavailableZones] = useState([]);
  const [availableStates, setavailableStates] = useState([]);
  const [availableBusiness, setavailableBusiness] = useState([]);


  const fetchData = async () => {
    var result1 = await getData("business");
    setavailableBusiness(result1.data);
    var result2 = await getData("zone");
    setavailableZones(result2.data);
    var result3 = await getData("state");
    setavailableStates(result3.data);
  };

  useEffect(() => {
    fetchData();
    return () => { };
  }, []);

  useEffect(() => {
    if (source === "zone") {
      setselectedSourceData(availableZones);
    } else if (source === "business") {
      setselectedSourceData(availableBusiness);
    } else if (source === "state") {
      setselectedSourceData(availableStates);
    } else {
      setselectedSourceData([]);
    }
    setValue("");

    return () => { };
  }, [source, availableBusiness, availableStates, availableZones]);

  const handleSearch = async (e, item) => {
    setloading(true);
    setdata([]);

    api_interceptor
      .post("search", { value: e, source: item })
      .then((res) => {
        if (res.data.status) {
          setdata(res.data.data);
        } else {
          alert(res.data.message);
        }
      })
      .catch((err) => {
        alert("Something went wrong");
      })
      .finally(() => setloading(false));
  };

  const DetailsComponent = () => {
    return data.length ? (
      data.map((item, index) => {
        return (
          <div key={index} className="mt-4 bg-white rounded-md">

              <div
                className={`w-full h-[30vh] sm:h-[50vh] overflow-hidden bg-no-repeat bg-cover`}
                style={{
                  background: `url(${ServerURL}/file/${item.FamilyPhoto || "not-found.jpg"
                    })`,
                  backgroundSize: "100%",
                  backgroundRepeat:'no-repeat',
                }}>
              </div>

            <div className="flex items-center sm:items-start flex-col sm:flex-row sm:ml-12 ">
              <div className="w-[30%] lg:w-[20%] mt-[-5%] overflow-hidden">
                <img
                  className="w-full aspect-square rounded-full border-4 border-gray-50 object-cover"
                  src={`${ServerURL}/file/${item.Photo || "mm"}`}
                  alt="self"
                />
              </div>
              <div className="flex flex-col items-center sm:items-start pr-2 mt-5 sm:mt-7 ml-2 sm:ml-6 break-words">
                <p className="text-purple-600 bg-purple-100 px-2 py-1 rounded-md font-medium text-sm">
                  {item.Occupation}
                </p>
                <p className="text-3xl font-medium">
                  {item.Name}
                  <span className="text-sm text-gray-500 font-medium">
                    {" "}
                    - ({item.Zone})
                  </span>
                </p>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="text-sky-700 block font-medium"
                  href={"mailto:" + item.Emailid}
                >
                  {item.Emailid}
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  className="text-sky-700 font-medium"
                  href={"tel:" + item.PrimaryContact}
                >
                  {item.PrimaryContact}
                </a>
                {item.State && <p>
                  {item.City} ({item.State})
                </p>}
              </div>
            </div>

            <div className="mt-5 sm:mt-7 sm:px-12 pb-5 ">
              <DisplayDataComponent name={"DOB"} value={item.DOB} />
              <DisplayDataComponent
                name={"Alternate No."}
                value={item.SecondaryContact}
              />
              <DisplayDataComponent name={"Spouse"} value={item.Spouse} />
              <DisplayDataComponent
                name={"Spouse D.O.B."}
                value={item.SpouseDob}
              />
              <DisplayDataComponent
                name={"Anniv. Date"}
                value={item.AnniversaryAt}
              />
              <DisplayDataComponent name={"Children"} value={item.Children} />
              <DisplayDataComponent
                name={"Business Web Link"}
                value={item.Businessweblink}
                link={true}
              />
              <DisplayDataComponent
                name={"Address"}
                value={item.Homeaddress}
              />
              <DisplayDataComponent
                name={"Office Address"}
                value={item.Officeaddress}
              />

              <DisplayDataComponent
                name={"Business Type"}
                value={item.BType1}
              />
              <DisplayDataComponent
                name={"Business Name"}
                value={item.Business1}
              />
              <DisplayDataComponent
                name={"B-Description"}
                value={item.BDescription1}
              />

              <DisplayDataComponent
                name={"Business Type"}
                value={item.BType2}
              />
              <DisplayDataComponent
                name={"Business Name"}
                value={item.Business2}
              />
              <DisplayDataComponent
                name={"B-Description"}
                value={item.BDescription2}
              />

              <DisplayDataComponent
                name={"Business Type"}
                value={item.BType3}
              />
              <DisplayDataComponent
                name={"Business Name"}
                value={item.Business3}
              />
              <DisplayDataComponent
                name={"B-Description"}
                value={item.BDescription3}
              />

              <DisplayDataComponent
                name={"Business Type"}
                value={item.BType4}
              />
              <DisplayDataComponent
                name={"Business Name"}
                value={item.Business4}
              />
              <DisplayDataComponent
                name={"B-Description"}
                value={item.BDescription4}
              />

              <DisplayDataComponent
                name={"Business Type"}
                value={item.BType5}
              />
              <DisplayDataComponent
                name={"Business Name"}
                value={item.Business5}
              />
              <DisplayDataComponent
                name={"B-Description"}
                value={item.BDescription5}
              />
            </div>
          </div>
        );
      })
    ) : (
      <></>
    );
  };

  return (
    <div className="justify-between flex flex-col h-[100vh]" >

    <div className="w-[90%] md:w-[70%] mx-auto">
     
      <nav className="my-4 p-3 bg-white rounded-md">
        {/* <img src="/images/logo.png" className="w-full self-center" alt="." /> */}
        <div className="overflow-hidden w-2/5 sm:w-1/5 mx-auto">
          <img
            src="/images/smalogo.png"
            className="w-full h-full self-center"
            alt="."
          />
        </div>
        <p className="text-center text-black font-semibold text-2xl sm:text-4xl pt-3 sm:pt-5">
          Business Directory
        </p>
      </nav>

      <div className="mt-4 bg-white rounded-xl border-l-4 border-[#5d5df1] py-5 px-5 sm:px-10 ">

          <div className="flex items-center justify-end" >
            <p className="font-medium mr-2" >New User ?</p>
            <button
              className="bg-[#5c33ae] p-[6px] text-sm text-white rounded-lg hover:bg-[#2f0e70]"
              onClick={() => {
                navigate('/')
              }}
            >
              Add Profile
            </button>
          </div>

          <div className="mt-3 flex items-center justify-end mb-4" >
            <p className="font-medium mr-2" >Existing user ?</p>
            <button
              className="bg-[#5c33ae] p-[6px] text-sm text-white rounded-lg hover:bg-[#2f0e70] "
              onClick={() => {
                navigate('/user')
              }}
            >
              Update Profile
            </button>
          </div>

        <div>
          <p className="font-medium">Search by</p>

          <select
            value={source}
            onChange={(event) => setSource(event.target.value)}
            className="border-[1px] px-3 py-2 rounded-md border-gray-300 mt-2 outline-none transition-all duration-300 focus:border-[#1976D2] focus:border-b-2  w-4/5 sm:w-3/5"
          >
            <option value={""}>--Please Select--</option>
            <option value={"name"}>Name</option>
            <option value={"zone"}>Zone</option>
            <option value={"city"}>City</option>
            <option value={"state"}>State</option>
            <option value={"business"}>Business Type</option>
          </select>
        </div>

        {source === "zone" || source === "state" || source === "business" ? (
          <select
            value={value}
            onChange={(event) => setValue(event.target.value)}
            className="border-[1px] px-3 py-2 rounded-md border-gray-300 mt-2 outline-none transition-all duration-300 focus:border-[#1976D2] focus:border-b-2 w-4/5 sm:w-3/5"
          >
            <option value={""}>--Please Select--</option>
            {selectedSourceData.map((item, index) => {
              const val =
                source === "zone" || source === "business"
                  ? item.Name
                  : item.StateName;
              return (
                <option key={index} value={val}>
                  {val}
                </option>
              );
            })}
          </select>
        ) : (
          <input
            id="text"
            value={value}
            placeholder={`Type ${source}`}
            onChange={(event) => setValue(event.target.value)}
            className="border-[1px] px-3 py-2 rounded-md border-gray-300 mt-2 outline-none transition-all duration-300 focus:border-[#1976D2] focus:border-b-2  w-4/5 sm:w-3/5"
            type="text"
          />
        )}

        <div className="pt-4">
          {loading ? (
            <div className="spinner"></div>
          ) : (
            <div>
              {" "}
              <button
                className="bg-[#5c33ae] px-4 text-sm py-2 text-white rounded-lg hover:bg-[#2f0e70]"
                type="submit"
                 onClick={() => handleSearch(value, source)}
                // onClick={() => alert("Will be available soon.")}
              >
                Search
              </button>
              <button
                className="bg-[#5c33ae] px-4 text-sm py-2 text-white rounded-lg hover:bg-[#2f0e70] ml-3 sm:ml-5"
                type="submit"
                 onClick={() => handleSearch("all", "all")}
                // onClick={() => alert("Will be available soon.")}
              >
                View All
              </button>
            </div>
          )}
        </div>
      </div>

      <div>
        <DetailsComponent />
      </div>
      
    </div>

      <footer className="mt-4 p-4 bg-gray-800 text-gray-200">
        <p className="text-center">Powered by Globe13 Digital Pvt. Ltd.</p>
      </footer>
    </div>
  );
}
